import Typography from './Typography'
export { type TypographyVariant } from './Typography'
export { type TypographyProps } from './Typography'

export default Typography
